import { Icon } from "@iconify/react";
import AvatarIcon from "../../components/icons/AvatarIcon";

export const userProfileBoard = [
  {
    title: "Profile",
    path: "profile",
    icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  },
  // {
  //   title: "Notification",
  //   path: "notification",
  //   icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  // },
  // {
  //   title: "Email Preferences",
  //   path: "emailPreference",
  //   icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  // },
  // {
  //   title: "Security",
  //   path: "security",
  //   icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  // },
];

export const profileDetails = [
  {
    id: 1,
    title: "Name",
    description: "Sarah Edem",
    text1: "edit",
    text2: "cancel",
    text3: "save",
  },
  {
    id: 2,
    title: "Email Address",
    description: "Sarahedem@Chevrontech.com",
    text1: "edit",
    text2: "cancel",
    text3: "save",
  },
  {
    id: 3,
    title: "Department",
    description: "Operations",
    text1: "edit",
    text2: "cancel",
    text3: "save",
  },
  {
    id: 4,
    title: "Position",
    description: "N/A",
    text1: "edit",
    text2: "cancel",
    text3: "save",
  },
];

export const credentialDetails = [
  {
    id: 1,
    label: "fingerprint",
  },
  {
    id: 2,
    label: "RFID card",
  },
  {
    id: 3,
    label: "PIN",
  },
  {
    id: 4,
    label: "mobile app",
  },
];
export const branches = [
  {
    id: 1,
    label: "New York",
  },
  {
    id: 2,
    label: "Lagos",
  },
  {
    id: 3,
    label: "Abuja",
  },
  {
    id: 4,
    label: "Florida",
  },
];

export const notificationDetails = [
  {
    id: 1,
    imageLink: "",
    name: "luchiSmart",
    message:
      "  Hi Sarah, welcome onboard! we hope your presence will greatly impact the growth and expansion of the company.",
    timeSent: "1 day ago",
  },
  {
    id: 2,
    imageLink: "",
    name: "Jonah Escort",
    message: " Have your issues been resolved?.",
    timeSent: "3 weeks ago",
  },
  {
    id: 3,
    imageLink: "",
    name: "Henry Benchwick",
    message: " Do check if resolved or pending.",
    timeSent: "1 month ago",
  },
];

export const emailPreferenceDetails = [
  {
    id: 1,
    value: "email",
    heading: "Email Notifications",
    description: " Recieve notifications on your email",
  },
  {
    id: 2,
    value: "recommend",
    heading: "Recommendations",
    description: "Check out our recommended devices",
  },
  {
    id: 3,
    value: "latest",
    heading: "Latest",
    description: "Stay current with the latest features and product launches",
  },
  {
    id: 4,
    value: "special",
    heading: "Special Occasions",
    description: "Choose to recieve special day communications ",
  },
  {
    id: 5,
    value: "unsubscribe",
    heading: "Unsubscribe from all",
    description: "You will recieve no further updates",
  },
];

export const adminUsers = [
  {
    id: 1,
    avatar: <AvatarIcon />,
    name: "May Greyson ",
    role: "Administrative user",
    location: "New York",
    email: "maygreyson@gmail.com",
    position: " head of IT",
    department: "Information Technology",
  },
  {
    id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Administrative user",
    location: "Lagos",
    email: "johnezeugo@gmail.com",
    position: "business analyst",
    department: "business and marketing",
  },
  {
    id: 3,
    avatar: <AvatarIcon />,
    name: "felistus ikenna ",
    role: "Administrative user",
    location: "Abuja",
    email: "felistusikenna@gmail.com",
    position: "IT supervisor",
    department: "information technology",
  },
  {
    id: 4,
    avatar: <AvatarIcon />,
    name: "endaline seyi ",
    role: "Administrative user",
    location: "Florida",
    email: "endalineseyi@gmail.com",
    position: "marketing analyst",
    department: "business and marketing",
  },
  {
    id: 5,
    avatar: <AvatarIcon />,
    name: "Dum seyike ",
    role: "Administrative user",
    location: "Florida",
    email: "dumseyike@gmail.com",
    position: "marketing analyst",
    department: "business and marketing",
  },
];
export const standardUsers = [
  {
    // id: 1,
    avatar: <AvatarIcon />,
    name: "Rosie Greyson ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Parker Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Idiot Amadi ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Babnana Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Pineapple ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Salad Soap ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Cream ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "John Obieze ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Jonathan Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Jonathan Ezeugo ",
    role: "Standard user",
  },
  {
    // id: 2,
    avatar: <AvatarIcon />,
    name: "Jonathan Ezeugo ",
    role: "Standard user",
  },
];
